import React, { useState, useEffect } from 'react';
import { Menu, X, Phone, Mail, MapPin, ChevronRight } from 'lucide-react';
import { practiceInfo } from '../data/mock';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: 'About', href: '#about' },
    { name: 'Services', href: '#services' },
    { name: 'Membership', href: '#membership' },
    { name: 'Blog', href: '#blog' },
    { name: 'Contact', href: '#contact' },
  ];

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        isScrolled
          ? 'bg-[#fffef8]/95 backdrop-blur-sm shadow-sm'
          : 'bg-transparent'
      }`}
    >
      {/* Top bar */}
      <div className="hidden lg:block border-b border-[#e8e7e2]">
        <div className="container-custom">
          <div className="flex justify-between items-center py-2 text-sm text-[#8a8a8a]">
            <div className="flex items-center gap-6">
              <a href={`tel:${practiceInfo.phone}`} className="flex items-center gap-2 hover:text-[#c9a962] transition-colors">
                <Phone size={14} />
                <span>{practiceInfo.phone}</span>
              </a>
              <a href={`mailto:${practiceInfo.email}`} className="flex items-center gap-2 hover:text-[#c9a962] transition-colors">
                <Mail size={14} />
                <span>{practiceInfo.email}</span>
              </a>
            </div>
            <div className="flex items-center gap-2">
              <MapPin size={14} />
              <span>{practiceInfo.address}</span>
            </div>
          </div>
        </div>
      </div>

      {/* Main navigation */}
      <nav className="container-custom">
        <div className="flex justify-between items-center py-5">
          {/* Logo */}
          <a href="#" className="flex items-center gap-3">
            <img
              src={practiceInfo.logo}
              alt="Exquisite Concierge Medicine"
              className="h-12 w-auto"
            />
            <div className="hidden sm:block">
              <span className="font-serif text-xl text-[#2d2d2d] tracking-wide">
                Exquisite
              </span>
              <span className="block text-xs text-[#8a8a8a] tracking-[0.2em] uppercase">
                Concierge Medicine
              </span>
            </div>
          </a>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center gap-10">
            {navLinks.map((link) => (
              <a
                key={link.name}
                href={link.href}
                className="text-link text-[#2d2d2d] text-sm tracking-wide"
              >
                {link.name}
              </a>
            ))}
          </div>

          {/* CTA Button */}
          <div className="hidden lg:flex items-end gap-4 pb-1">
            <a 
              href="https://34416-1.portal.athenahealth.com" 
              target="_blank" 
              rel="noopener noreferrer"
              className="btn-primary"
            >
              Patient Portal
            </a>
            <a href="#contact" className="btn-gold">
              Schedule Consultation
              <ChevronRight size={16} />
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="lg:hidden p-2"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="lg:hidden py-6 border-t border-[#e8e7e2] animate-fade-in">
            <div className="flex flex-col gap-4">
              {navLinks.map((link) => (
                <a
                  key={link.name}
                  href={link.href}
                  className="text-[#2d2d2d] text-base py-2 hover:text-[#c9a962] transition-colors"
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  {link.name}
                </a>
              ))}
              <a
                href="https://34416-1.portal.athenahealth.com"
                target="_blank"
                rel="noopener noreferrer"
                className="btn-primary mt-4 text-center"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                Patient Portal
              </a>
              <a
                href="#contact"
                className="btn-gold mt-2 text-center"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                Schedule Consultation
              </a>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
};

export default Header;
